<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="400px"
  >
    <v-card>
      <v-card-title class="headline pa-3">
        <v-text-field
          v-model.trim="search"
          append-icon="mdi-magnify"
          label="Search accounts"
          single-line
          clearable
          outlined
          hide-details
          dense
        />
      </v-card-title>
      <v-divider />
      <v-card-text class="px-0">
        <v-list class="py-0">
          <div
            v-for="account in filteredAccounts"
            :key="`accounts--${account.id}`"
          >
            <v-list-item>
              <v-list-item-title>
                <span
                  class="action"
                  @click="goTo(account)"
                >
                  {{ account.name }}
                </span>
              </v-list-item-title>
              <v-list-item-action>
                <v-btn
                  v-if="!unlink"
                  icon
                  color="error"
                  small
                  @click="linkAccounts(account)"
                >
                  <v-icon small>
                    mdi-plus
                  </v-icon>
                </v-btn>

                <!-- <v-btn
                  v-else
                  icon
                  color="success"
                  small
                  @click="unlinkAccounts(account)"
                >
                  <v-icon small>
                    mdi-close
                  </v-icon>
                </v-btn> -->
              </v-list-item-action>
            </v-list-item>
            <v-divider />
          </div>
          <div
            v-if="!filteredAccounts.length && search"
            class="py-3"
            align="center"
          >
            No records found. reset the search
          </div>
        </v-list>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          class="white--text"
          @click.native="close()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AssignAccountToStore",
  data() {
    return {
      dialog: false,
      accounts: [],
      search: "",
      tenantId: null,
      unlink: false
    };
  },
  computed: {
    filteredAccounts() {
      if (this.search) {
        const searchText = this.search.toUpperCase();
        return this.accounts.filter((account) => {
          return account.name.toUpperCase().indexOf(searchText) > -1;
        });
      }
      return this.accounts;
    }
  },
  methods: {
    close() {
      this.dialog = false;
      this.tenantId = null;
      this.accounts = [];
    },
    open(id) {
      this.tenantId = id;
      this.unlink = false;
      this.$http
        .get(`${this.ADMIN_API_URL}/getUnassignedAccounts`)
        .then(function (data) {
          this.accounts = data.body;
          this.dialog = true;
        });
    },
    openAssignedAccounts(id, accounts) {
      this.unlink = true;
      this.tenantId = id;
      this.accounts = accounts;
      this.dialog = true;
    },
    linkAccounts(account) {
      this.$root.$confirm
        .open("Confirm", `Are you sure you to add "${account.name}"?`, {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.req = {
            accountId: account.id,
            tenantId: this.tenantId
          };
          this.$http
            .post(
              `${this.ADMIN_API_URL}/inventory/tenants/${this.tenantId}/linkAccounts`,
              this.req
            )
            .then(
              function (data) {
                this.handleSuccess(data.body);
              },
              function (failure) {
                this.handleFailure(failure);
              }
            );
        });
    },
    handleSuccess(response) {
      this.$emit("reload");
      this.close();
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
    },
     handleFailure: function (failure) {
      let msg = failure.body.message || "Error";
      let errors = failure.body.errors;
      if (errors && errors.Name) {
        msg = errors.Name;
      }
      this.$store.commit("showSnackbar", {
        message: msg,
        color: "error"
      });
    },
    goTo(account) {
      this.$router.push({
        name: "accountInfo",
        params: {
          accountId: account.id
        }
      });
    }
  }
};
</script>

<style scoped>
.action {
  text-decoration: underline;
  cursor: pointer;
}
</style>